namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_app_overlay, {

		background: {
			color: 'transparent',
		},
		justify: {
			content: 'center',
		},
		position: 'fixed',
		pointerEvents: 'none',
		bottom: 0,
		width: '100%',
		zIndex: 6,

		borderStyle: 'none',
		borderWidth: '0px',
		padding: 0,
		height: '100vh',

		Overlayed_map_holder: {
			position: 'absolute',
			inset: '0',
			pointerEvents: 'none',
		},

		Quick_access: {
			position: 'absolute',
			bottom: '1rem',
		},

		Fullscreen_panel: {
			position: 'fixed',
			right: 0,
			top: 0,
			bottom: 0,
			width: '40px',
			flex: { direction: 'column' },
			align: { items: 'stretch' },
			background: { color: $mol_theme.card },
			border: { left: { width: '1px', style: 'solid', color: $mol_theme.line } },
			zIndex: 7,
			pointerEvents: 'auto',
		},

		Fullscreen_zoom_out: {
			padding: 0,
			width: '40px',
			height: '40px',
			minWidth: '40px',
			minHeight: '40px',
			align: { items: 'center' },
			justify: { content: 'center' },
			flex: { grow: 0, shrink: 0 },
		},
		Fullscreen_zoom_in: {
			padding: 0,
			width: '40px',
			height: '40px',
			minWidth: '40px',
			minHeight: '40px',
			align: { items: 'center' },
			justify: { content: 'center' },
			flex: { grow: 0, shrink: 0 },
		},
		Fullscreen_close: {
			padding: 0,
			width: '40px',
			height: '40px',
			minWidth: '40px',
			minHeight: '40px',
			align: { items: 'center' },
			justify: { content: 'center' },
			flex: { grow: 0, shrink: 0 },
		},
		
	} )
	
}
